import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from '@trileuco/triskel-react-ui/components/i18n'

import BookableWysiwygBlock from './BookableWysiwygBlock'

const BookableRecommendationsBlock = ({ bookable }) => {
  const { msg } = useIntl({ scope: '' })
  return (
    <BookableWysiwygBlock
      title={msg({ id: 'recommendations' })}
      content={bookable.info.recommendations}
    />
  )
}

BookableRecommendationsBlock.propTypes = {
  bookable: PropTypes.shape()
}

BookableRecommendationsBlock.displayName = 'BookableRecommendationsBlock'

export default BookableRecommendationsBlock
